/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/198-download2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M14 8h-2.5L8 11.5 4.5 8H2l-2 4v1h16v-1l-2-4zM0 14h16v1H0v-1zm9-9V1H7v4H3.5L8 9.5 12.5 5H9z"/>'
  }
})
